<template>
  <b-card no-body class="container-card p-2 card-create">
    <b-row>
      <b-col cols="12">
        <b-col cols="12" class="">
          <label for="open-close" class="font-medium-5">
            Open/Close
          </label>
          <b-form-checkbox
            field-value="true"
            class="custom-control-success custom-toggle"
            name="check-button"
            v-model="formData.status"
            switch
          >
            <span class="switch-icon-left toggle-text">{{ "Open" }}</span>
            <span class="switch-icon-right toggle-text">{{ "Close" }}</span>
          </b-form-checkbox>
        </b-col>

        <!--  -->
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-col cols="12" class="mt-1">
              <label for="campaign-name" class="required font-medium-5">
                Campaign Name
              </label>
              <b-form-input
                id="campaign-name"
                placeholder="ระบุ..."
                required
                class="textbox-input"
                v-model="formData.campaignName"
              />
            </b-col>
            <b-col cols="12" class="mt-1">
              <label for="desription" class="font-medium-5">
                Description
              </label>
              <b-form-textarea
                id="description"
                placeholder="ระบุ..."
                class="textbox-input"
                :max-rows="4"
                :rows="4"
                v-model="formData.description"
              />
            </b-col>
            <!--  -->
            <b-col cols="12" class="mt-1">
              <label for="valid-from-date" class="required font-medium-5">
                Valid From
              </label>
              <div class="d-flex">
                <div class="p-relative mr-1 w-50 mr-2">
                  <calendar-picker-icon class="icon-calendar bypass" />
                  <flat-pickr
                    :id="'valid-from-date'"
                    v-model="formData.validFrom.date"
                    class="form-control  bg-date"
                    :config="flatpickrDateConfig"
                    placeholder="Start Date"
                    required
                    autocomplete="off"
                    @on-open="onOpenValidFromDatePicker"
                    @on-change="onSelectValidFromDate"
                  />
                </div>
                <div class="p-relative w-50 ml-2">
                  <clock-picker-icon
                    class="icon-calendar date-picker-icon bypass"
                    :class="
                      formData.validFrom.time ? 'date-selected-icon' : null
                    "
                  />
                  <flat-pickr
                    id="valid-from-time"
                    v-model="formData.validFrom.time"
                    class="form-control  bg-date"
                    :class="formData.validFrom.time ? 'date-selected' : null"
                    :config="flatpickrTimeConfig"
                    :placeholder="'HH : mm'"
                    required
                    autocomplete="off"
                    @on-open="onOpenValidFromTimePicker"
                    @on-change="onSelectValidFromTimePicker"
                  />
                </div>
              </div>
            </b-col>
            <!--  -->
            <b-col cols="12" class="my-1">
              <label for="valid-from-to" class="required font-medium-5">
                Valid Through
              </label>
              <div class="d-flex">
                <div class="p-relative w-50 mr-2">
                  <calendar-picker-icon
                    class="icon-calendar bypass"
                    :class="
                      formData.validThrough.date ? 'date-selected-icon' : null
                    "
                  />
                  <flat-pickr
                    :id="'valid-to-date'"
                    v-model="formData.validThrough.date"
                    class="form-control  bg-date"
                    :class="formData.validThrough.date ? 'date-selected' : null"
                    :config="flatpickrDateConfig"
                    placeholder="End Date"
                    required
                    autocomplete="off"
                  />
                </div>
                <div class="p-relative w-50 ml-2">
                  <clock-picker-icon
                    class="icon-calendar date-picker-icon bypass"
                    :class="
                      formData.validThrough.time ? 'date-selected-icon' : null
                    "
                  />
                  <flat-pickr
                    id="valid-from-time"
                    v-model="formData.validThrough.time"
                    class="form-control  bg-date"
                    :class="formData.validThrough.time ? 'date-selected' : null"
                    :config="flatpickrTimeConfig"
                    :placeholder="'HH : mm'"
                    required
                    autocomplete="off"
                    @on-open="onOpenValidThroughTimePicker"
                  />
                </div>
              </div>
            </b-col>
          </b-col>
          <!--  -->

          <!--  -->
          <b-col cols="12" md="6">
            <b-col cols="12" class="mt-1">
              <label for="Section" class="font-medium-5">
                Section
              </label>
              <b-form-input
                id="Section"
                placeholder="ระบุ..."
                class="textbox-input"
                v-model="formData.section"
              />
            </b-col>
            <b-col cols="12" class="mt-1">
              <label for="image1" class="font-medium-5"> Image or Banner </label>
              <image-uploader
                :image-url="formData.image_1.url"
                @onUpload="onUploadImage"
              />
            </b-col>
          </b-col>
        </b-row>
        <!--  -->
        <!--  -->
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import flatPickr from "vue-flatpickr-component";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ImageUploader from "@core/components/image-uploader/ImageUploader.vue";

export default {
  components: {
    flatPickr,
    ClockPickerIcon,
    CalendarPickerIcon,
    ImageUploader,
  },
  props: {
    formData: { type: Object, default: {} },
  },
  setup(props) {
    const {
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onSelectValidFromDate,
      onOpenValidFromTimePicker,
      onSelectValidFromTimePicker,
      onOpenValidThroughTimePicker,
    } = useFlatPickr();

    const onUploadImage = (image) => {
      props.formData.image_1.file = image.file;
      props.formData.image_1.url = image.url;
    };

    return {
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onSelectValidFromDate,
      onOpenValidFromTimePicker,
      onSelectValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onUploadImage
    };
  },
};
</script>

<style></style>
